import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingService } from 'src/app/services/loading.service';

import { UserModel } from 'src/app/services/user-model';
import { Title } from '@angular/platform-browser';
import { SettingsProvider } from 'src/app/services/settings';
import { HttpClientProvider } from 'src/app/services/http-client';

import Swal from 'sweetalert2';
import { NotificationService } from 'src/app/services/notification.service';
import { XtrasService } from 'src/app/services/xtras.service';
import { UserService } from 'src/app/services/user.service';
import { FormGroup, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { MainService } from 'src/app/services/main.service';
import { UtilsService } from 'src/app/services/utils.service';

declare var $: any;

@Component({
  selector: 'app-roles',
  templateUrl: './roles.page.html',
  styleUrls: ['./roles.page.scss'],
})
export class RolesPage implements OnInit {
  filtersForm: FormGroup = new FormGroup({
    role: new FormControl(''),
    status: new FormControl('')
  });

  displayedColumns: any = [
    {variable: 'rowNumber', displayedName: 'N.'},
    {variable: 'options-roles', displayedName: 'Acciones'},
    {variable: 'display_name', displayedName: 'Rol'},
    {variable: 'permissions_concat', displayedName: 'Permisos'},
    {variable: 'created_at', displayedName: 'Fecha de creación'},
  ];

  dataSource: any = [];
  roles: any = [];
  status: any = this.uService.userStatuses;
  filterTerm: string = '';
  filterTerm2: string = '';
  userPermissions: any = this.uService.userPermissions.roles;

  getRolesFilter(){
    this.mService.get_request('rol/list')
    .subscribe((resp: any)=>{
      var rolesToReturn = [];
      if(resp.status){
        // this.roles = resp.items;
        Object.keys(resp.items).forEach(element => {
          rolesToReturn.push({ name: resp.items[element].role_name})
        });
        this.roles = rolesToReturn;
      }else{
        this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
        if(resp.message.includes('expirado')){
          this.uService.logOut$.next(true);
        }
      }
    })
  }

  getExcel(){
    var fields = this.uService.avoidEmptyFields(this.filtersForm);
    var concat_url = `${this.getUrl()}rol/list?export_excel=true`

    for (const key in fields) {
      if (Object.prototype.hasOwnProperty.call(fields, key)) {
        concat_url = concat_url + '&' + key + '=' + fields[key];
      }
    }
    window.open(concat_url, '_blank');
  }

  getRoles(){
    this.mService.get_request('rol/list')
    .subscribe((resp: any)=>{
      if(resp.status){
        var roleResp: any = [];
        for (const key in resp.items) {
          var permissions_concat: string = '---';
          for (const permKey in resp.items[key].permissions) {
            var permissions = resp.items[key].permissions[permKey];

            permissions.forEach(permission => {
              if(permissions_concat == '---'){
                permissions_concat = permission.display_name;
              }else{
                permissions_concat += `, ${permission.display_name}`;
              }
            });
          }
          roleResp.push({
            ...resp.items[key],
            permissions_concat
          })
        }
        this.dataSource = roleResp;
      }else{
        this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
        if(resp.message.includes('expirado')){
          this.uService.logOut$.next(true);
        }
      }
    })
  }

  getUrl(): string{
    return this.uService.getUrl();
  }

  constructor(private mService: MainService, private uService: UtilsService, private toast: ToastrService) {
    this.getRoles();
    // this.getRolesFilter();
  }

  ngAfterViewInit() {
  }

  ngOnInit(): void {}
}
